export const scannerVideoDeviceIdSelector = ({scanner}) => scanner.videoDeviceId;
